import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { formValueSelector } from 'redux-form';
import Button from '../../../../components/Button';
import CloakLoading from '../../../../components/CloakLoading';
import FlexGrid, { FlexGridColumn } from '../../../../components/FlexGrid';
import PaddingBox from '../../../../components/PaddingBox';
import Translations from '../../../../containers/Translations';
import { codes } from '../../../../data/translations';
import { FORM_REGISTER_PASSWORD_NAME } from '../../consts';
import AuthenticationConfirmationBox from '../AuthenticationConfirmationBox';
import AuthenticationTwoStepEnterCode from '../AuthenticationTwoStepEnterCode';
import AuthenticationTwoStepController from './decorators/authenticationTwoStepController';
import classes from './styles/button.module.scss';

const AuthenticationTwoStepComponent = ({
	isPending,
	authAppData,
	handleAuthAppSend,
	errors,
	handleResetAuthenticatorApp,
	translate,
	isConfirmationResetTwoStepAuth,
	handleShowConfirmationReset,
	handleHideConfirmationReset,
}) => {
	return (
		<>
			{isPending && <CloakLoading />}
			{!isPending && (
				<>
					{isConfirmationResetTwoStepAuth && (
						<AuthenticationConfirmationBox
							message={translate(codes.user.resetAuthenticatorAppConfirmation)}
							renderButtons={
								<FlexGrid spaceBetween>
									<FlexGridColumn grow>
										<PaddingBox rightTiny>
											<Button
												primary
												block
												onClick={handleResetAuthenticatorApp}
												size='small'
												className={classes.button}
											>
												{translate(codes.reset)}
											</Button>
										</PaddingBox>
									</FlexGridColumn>
									<FlexGridColumn grow>
										<PaddingBox leftTiny>
											<Button
												link
												onClick={handleHideConfirmationReset}
												size='small'
												block
												className={classes.button}
											>
												{translate(codes.cancel)}
											</Button>
										</PaddingBox>
									</FlexGridColumn>
								</FlexGrid>
							}
						/>
					)}
					{!isConfirmationResetTwoStepAuth && (
						<AuthenticationTwoStepEnterCode
							{...authAppData}
							handleAuthAppSend={handleAuthAppSend}
							handleShowConfirmationReset={handleShowConfirmationReset}
							errors={errors}
							translate={translate}
						/>
					)}
				</>
			)}
		</>
	);
};

const selector = formValueSelector(FORM_REGISTER_PASSWORD_NAME);

export const AuthenticationTwoStep = compose(
	Translations,
	connect((state) => ({
		isPersistent: selector(state, 'isPersistent'),
	})),
	AuthenticationTwoStepController,
)(AuthenticationTwoStepComponent);
